import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2662f3ff&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2662f3ff&prod&scoped=true&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=2662f3ff&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2662f3ff",
  null
  
)

export default component.exports